import { useApp } from "./useApp";

export const useSocialShare = () => {
  const {
    config: {
      settings: {
        socialMedia: { sharing },
      },
    },
  } = useApp();

  const socialShare = (type, link, image, wishlist) => {
    const subject = wishlist
      ? `Check my wishlist on Bared footwear`
      : `Check this article I found on Bared footwear`;
    switch (type) {
      case "email":
        window.open(`mailto:?subject=${subject}&body=${link}`, "_blank");
        break;
      case "facebook":
        window.open(
          `${sharing.facebook}${encodeURIComponent(link)}`,
          "facebook-popup",
          "height=400,width=600",
        );
        break;
      case "pinterest":
        window.open(
          `${sharing.pinterest}${link}&media=${image.src}&description=${image.description}`,
        );
        break;
      default:
        break;
    }
  };

  return {
    socialShare,
  };
};
